import { isDogfoodEnv } from 'owa-metatags';

export function getAugloopServiceUrl(): string {
    return isDogfoodEnv() ? 'https://augloop-dogfood.officeppe.com' : 'https://augloop.office.com';
}
